import * as ep from "../../endpoints";
import api from "@/libs/axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Vue from "vue";
export default {
  namespaced: true,
  state: {
    loading: false,
    services:[],
  },
  getters: {
    loading(state) {
      return state.loading;
    },
    services(state){
      return state.services;
    }
  },
  mutations: {},
  actions: {
    async updateServices(context, payload) {
      context.state.loading = true;
      await api.put(ep.SERVICES_BY_ID(payload.id), payload.data).then((res) => {
        context.state.loading = false;
        Vue.$toast({
          component: ToastificationContent,
          props: {
            title: res.data.message,
            icon: res.data.status ? "CheckIcon": "XIcon",
            variant: res.data.status ? "success" :"danger",
          },
        });
      }).catch((err) => {
        console.log(err);
      })
      .finally(() => {
        context.state.loading = false;
      });;
    },

    
    async createServices(context, payload) {
      context.state.loading = true;
      await api
        .post(ep.SERVICES, payload.data)
        .then((res) => {
          context.state.loading = false;
          Vue.$toast({
            component: ToastificationContent,
            props: {
              title: res.data.message,
              icon: res.data.status ? "CheckIcon": "XIcon",
              variant: res.data.status ? "success" :"danger",
            },
          });
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          context.state.loading = false;
        });
    },
    async deleteServices(context, payload) {
      context.state.loading = true;
      await api.delete(ep.SERVICES_BY_ID(payload.id)).then((res) => {
        context.state.loading = false;
        Vue.$toast({
          component: ToastificationContent,
          props: {
            title: res.data.message,
            icon: res.data.status ? "CheckIcon": "XIcon",
            variant: res.data.status ? "success" :"danger",
          },
        });
      });
    },
  },
};
